{
  "name": "ng-avalon-surveys",
  "version": "2026.1.22",
  "scripts": {
    "ng": "ng",
    "start": "ng serve",
    "prebuild": "node scripts/version-write.js",
    "build": "npm run prebuild && ng build",
    "build:uat": "npm run prebuild && ng build --configuration=uat",
    "build:dev": "npm run prebuild && ng build --configuration=development",
    "watch": "npm run prebuild && ng build --watch --configuration development",
    "test": "ng test"
  },
  "overrides": {
    "vite": "7.3.2"
  },
  "private": true,
  "engines": {
    "npm": ">=7.0.0",
    "node": ">=20.19.0"
  },
  "dependencies": {
    "@angular/animations": "^21.2.12",
    "@angular/cdk": "21.2.5",
    "@angular/common": "^21.2.12",
    "@angular/compiler": "^21.2.12",
    "@angular/core": "^21.2.12",
    "@angular/forms": "^21.2.12",
    "@angular/localize": "^21.2.12",
    "@angular/platform-browser": "^21.2.12",
    "@angular/platform-browser-dynamic": "^21.2.12",
    "@angular/router": "^21.2.12",
    "@angular/service-worker": "^21.2.12",
    "@awesome.me/kit-c84edb1fca": "^1.0.6",
    "@ng-bootstrap/ng-bootstrap": "^20.0.0",
    "angular-auth-oidc-client": "^21.0.2",
    "bootstrap": "^5.3.8",
    "dompurify": "^3.4.5",
    "gsap": "^3.14.2",
    "ng-connection-service": "^13.0.2",
    "ngx-indexed-db": "^22.0.0",
    "ngx-toastr": "^20.0.4",
    "rxjs": "~7.8.0",
    "tslib": "^2.8.1",
    "ua-parser-js": "^2.0.8"
  },
  "devDependencies": {
    "@angular/build": "^21.2.11",
    "@angular/cli": "^21.2.11",
    "@angular/compiler-cli": "^21.2.12",
    "@types/crypto-js": "^4.2.2",
    "@types/jasmine": "~5.1.0",
    "baseline-browser-mapping": "^2.10.14",
    "jasmine-core": "~5.13.0",
    "karma-chrome-launcher": "~3.2.0",
    "typescript": "~5.9.3"
  }
}
